import React, { useCallback, useEffect, useState } from "react";
import {
    collection,
    getDocs,
    deleteDoc,
    doc
} from "firebase/firestore";

import { useParams } from "react-router-dom";
import { db } from "../../firebase/firebase";

import "../../assets/css/admin/manageVideos.css";
import VideoModal from "../../components/Gallery/VideoModal";



function ManageVideos() {

    const { category } = useParams();

    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);

const [selectedDeleteId, setSelectedDeleteId] = useState(null);

const [popup, setPopup] = useState({
    show: false,
    type: "",
    message: ""
});

    const loadVideos = useCallback(async () => {

        try {

            setLoading(true);

            const data = [];

            const snapshot = await getDocs(
                collection(db, "videos")
            );

            snapshot.forEach((doc) => {

                const item = {
                    id: doc.id,
                    ...doc.data()
                };

               if (category === "All" || item.category === category) {
    data.push(item);
}

            });

            setVideos(data);

        } catch (error) {

            console.log(error);

        } finally {

            setLoading(false);

        }

    }, [category]);

    useEffect(() => {

        loadVideos();

    }, [loadVideos]);

    if (loading) {

        return (
            <div className="manage-gallery">
                <h2>Loading Videos...</h2>
            </div>
        );

    }
  const deleteVideo = (id) => {

    setSelectedDeleteId(id);

    setDeleteModal(true);

};

const confirmDeleteVideo = async () => {

    try {

        await deleteDoc(
            doc(db, "videos", selectedDeleteId)
        );

        setPopup({
            show: true,
            type: "success",
            message: "Video Deleted Successfully"
        });

        loadVideos();

    }

    catch (error) {

        console.log(error);

        setPopup({
            show: true,
            type: "error",
            message: "Failed to Delete Video"
        });

    }

    finally {

        setDeleteModal(false);

        setSelectedDeleteId(null);

        setTimeout(() => {

            setPopup({
                show: false,
                type: "",
                message: ""
            });

        }, 3000);

    }

};
    return (
        <>{popup.show && (

    <div className={`luxury-popup ${popup.type}`}>

        <div className="popup-icon">

            {popup.type === "success" ? "✓" : "✕"}

        </div>

        <div className="popup-content">

            <h3>

                {popup.type === "success"
                    ? "Success"
                    : "Error"}

            </h3>

            <p>{popup.message}</p>

        </div>

    </div>

)}
{deleteModal && (

    <div className="delete-modal-overlay">

        <div className="delete-modal">

            <div className="delete-modal-icon">

                🗑

            </div>

            <h2>

                Delete Video

            </h2>

            <p>

                Are you sure you want to delete this video?

            </p>

            <div className="delete-modal-actions">

                <button
                    className="delete-cancel-btn"
                    onClick={() => {

                        setDeleteModal(false);

                        setSelectedDeleteId(null);

                    }}
                >

                    Cancel

                </button>

                <button
                    className="delete-confirm-btn"
                    onClick={confirmDeleteVideo}
                >

                    Delete

                </button>

            </div>

        </div>

    </div>

)}

        <div className="manage-gallery">

            <div className="manage-header">

                <h1>{category} Videos</h1>

            </div>

            {videos.length === 0 ? (

                <div className="empty-box">

                    <h2>No Videos Found</h2>

                </div>

            ) : (

                <div className="video-gallery-grid">

                    {videos.map((video) => (

                        <div
                            className="video-gallery-card"
                            key={video.id}
                        >

                            <video
                                controls
                                className="video-gallery-video"
                            >
                                <source
                                    src={video.videoUrl}
                                    type="video/mp4"
                                />
                            </video>
<div className="video-gallery-content">

    <h3>{video.title}</h3>

    <div className="video-gallery-buttons">

<button
    className="video-view-btn"
    onClick={() => setSelectedVideo(video)}
>
    View
</button>

        <button
            className="video-delete-btn"
            onClick={() => deleteVideo(video.id)}
        >
            Delete
        </button>

    </div>

</div>

                        </div>

                    ))}

                </div>

            )}
           
           {selectedVideo && (

    <div
        className="photo-modal"
        onClick={() => setSelectedVideo(null)}
    >

        <div
            className="modal-content"
            onClick={(e) => e.stopPropagation()}
        >

            <button
                className="close-btn"
                onClick={() => setSelectedVideo(null)}
            >
                ×
            </button>

            <video
                controls
                autoPlay
                style={{
                    width: "100%",
                    maxHeight: "75vh"
                }}
            >

                <source
                    src={selectedVideo.videoUrl}
                    type="video/mp4"
                />

            </video>

            <h2>{selectedVideo.title}</h2>

        </div>
<VideoModal
    video={selectedVideo}
    onClose={() => setSelectedVideo(null)}
/>
    </div>

)}
        </div>
  </>
    );

}

export default ManageVideos;